import { create } from 'zustand';

/** Whether the screen is locked after idling (ToR 4.3.2); the session itself stays. */
interface LockState { locked: boolean; lock: () => void; unlock: () => void }

export const useLockStore = create<LockState>()((set) => ({
  locked: false,
  lock: () => set({ locked: true }),
  unlock: () => set({ locked: false }),
}));
